export default function FAQSection() {
  const faqs = [
    {
      q: '非麻瓜漫画是免费的吗？',
      a: '是的，非麻瓜漫画完全免费！我们提供海量韩国漫画资源，所有漫画均可免费在线阅读，无需注册账号，无需付费订阅，打开网站即可畅享韩漫阅读体验。',
    },
    {
      q: '什么是下拉式阅读？',
      a: '下拉式阅读是一种专为移动端优化的漫画阅读模式。与传统的翻页模式不同，下拉式阅读将整话漫画连续纵向排列，读者只需向下滑动屏幕即可流畅阅读，无需点击翻页按钮，阅读体验更加沉浸和自然。',
    },
    {
      q: '漫画更新频率如何？',
      a: '我们每天都会更新最新的韩国漫画内容。热门连载漫画通常会在韩文原版更新后的24小时内提供中文翻译版本，确保您能第一时间追更喜欢的作品。',
    },
    {
      q: '需要下载APP吗？',
      a: '不需要！非麻瓜漫画是纯网页端平台，您只需使用浏览器访问我们的网站即可阅读。我们建议将网站添加到手机桌面，即可获得类似APP的使用体验。',
    },
    {
      q: '如何找到我想看的漫画？',
      a: '您可以通过首页的分类导航浏览不同题材的漫画，也可以使用搜索功能直接搜索漫画名称。我们还设有"热门推荐"和"最新上架"板块，帮助您发现优质漫画内容。',
    },
    {
      q: '漫画画质如何？',
      a: '非麻瓜漫画所有内容均为高清全彩画质。我们采用先进的图片压缩和加载技术，在保证画质的前提下优化加载速度，让您享受流畅清晰的阅读体验。',
    },
  ];

  const jsonLd = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: faqs.map((faq) => ({
      '@type': 'Question',
      name: faq.q,
      acceptedAnswer: {
        '@type': 'Answer',
        text: faq.a,
      },
    })),
  };

  return (
    <section className="py-14 md:py-20 bg-background-100">
      <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>
      <div className="w-full px-4 md:px-6 lg:px-10 max-w-3xl mx-auto">
        <div className="text-center mb-10">
          <span className="inline-block px-4 py-1.5 bg-secondary-200 text-secondary-700 text-xs font-medium rounded-full mb-3">
            常见问题
          </span>
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
            你可能会问
          </h2>
        </div>

        <div className="flex flex-col gap-3">
          {faqs.map((faq, index) => (
            <details key={index} className="group bg-background-50 rounded-lg overflow-hidden cursor-pointer">
              <summary className="flex items-center justify-between px-5 py-4 text-sm md:text-base font-medium text-foreground-900 hover:text-primary-600 transition-colors list-none">
                <span>{faq.q}</span>
                <span className="w-5 h-5 flex items-center justify-center text-foreground-400 group-open:rotate-180 transition-transform">
                  <i className="ri-arrow-down-s-line"></i>
                </span>
              </summary>
              <div className="px-5 pb-4 text-sm text-foreground-600 leading-relaxed">
                {faq.a}
              </div>
            </details>
          ))}
        </div>
      </div>
    </section>
  );
}